import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { notificationActions } from '../../../notifications/actions/notification';
import { QueuesAlertsForm as QueuesAlertsFormImpl, waitingConversationField, } from '../components/queuesAlertsForm';
const FORM_NAME = 'queuesAlertsForm';
function validate({ waiting_conversations, }) {
    const errors = {};
    if (waiting_conversations > 500) {
        errors[waitingConversationField] = 'Must be less than or equal to 500';
    }
    return errors;
}
const queueAlertsFormSelector = formValueSelector(FORM_NAME);
const mapStateToProps = (state) => ({
    formValues: queueAlertsFormSelector(state, 'is_sla_percentage', 'sla_percentage', 'is_longest_wait', 'longest_wait', 'is_available_agents', 'available_agents', 'is_waiting_conversations', 'waiting_conversations'),
});
const mapDispatchToProps = (dispatch) => ({
    notificationAdd: (payload) => dispatch(notificationActions.notificationAdd(payload)),
});
const QueuesAlertsForm = reduxForm({
    form: FORM_NAME,
    enableReinitialize: true,
    validate,
})(QueuesAlertsFormImpl);
const QueuesAlertsFormConnected = connect(mapStateToProps, mapDispatchToProps)(QueuesAlertsForm);
export { QueuesAlertsFormConnected as QueuesAlertsForm };
